import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  status: null,
  message: null,
  data: null,
};

const chatbotReducer = createReducer(initialState, {
  USER_CHATBOT_REQ: (state) => {
    state.loading = true;
    state.chatbotResponse = null;
  },
  USER_CHATBOT_FETCH_SUC: (state, actions) => {
    const payload = actions.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data;
  },
  USER_CHATBOT_ERROR: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
  }
});

export default chatbotReducer;
